module.exports = __webpack_public_path__ + "img/examine.b7fda051.svg";